import zsenie from 'images/zsenie.png'
import zsenieIcon from 'images/zsenieLogoSmall.png'

const imagePath = (zsenie) => images(zsenie, true)
const imagePath2  = (zsenieIcon) => images(zsenieIcon, true)

function initMenu() {
    if ($("#containerForUser").length > 0) {
        var navbarBottomArr = [
            "<a class='fa fa-users fa-lg' href='/users' id='usersInsideBar' rel='nofollow' title=" + I18n.t("team.headers.team") + "></a>",
            "<a class='fa fa-question-circle fa-lg' href='/contacts/new' id='contactsInsideBar' rel='nofollow' title=" + I18n.t("fields.contact_us") + "></a>",
            "<a class='fa fa-video fa-lg' href='/howto' id='videosInsideBar' rel='nofollow' title=" + I18n.t("menu.header.how_to_index") + "></a>",
            "<a class='fa fa-cog fa-lg' href='/settings' id='settingsInsideBar' rel='nofollow' title=" + I18n.t("fields.settings") + "></a>"
        ];
        var iconBarTop = [
            "<a class='fa fa-crosshairs fa-lg' href='/creations' id='creationsHeaderButton' rel='nofollow' title=" + I18n.t("fields.creations") + "></a>",
            "<a class='" + I18n.t('icons.product') + "' href='/products' id='productsHeaderButton' rel='nofollow' title=" + I18n.t("fields.products") + "></a>",
            "<a class='" + I18n.t('icons.request') + "' href='/requests' id='requestsHeaderButton' rel='nofollow' title=" + I18n.t("fields.requests") + "></a>",
            "<a class='fa fa-map fa-lg' href='/blueprints' id='blueprintsHeaderButton' rel='nofollow' title=" + I18n.t("fields.blueprints") + "></a>",
            "<a class='fa fa-table fa-lg' href='/organization_tables' id='tablesHeaderButton' rel='nofollow' title=" + I18n.t("fields.tables") + "></a>",
            "<a class='fa fa-book fa-lg' href='/journal/posts' id='journalHeaderButton' rel='nofollow' title=" + I18n.t("journal.headers.journals") + "></a>"
        ];
        var iconBarBottom = [
            "<a class='fa fa-space-shuttle fa-lg' href='/resources' id='resourcesHeaderButton' rel='nofollow' title=" + I18n.t("fields.resources") + "></a>",
            "<a class='fa fa-shopping-cart fa-lg' href='/items' id='inventoryIconButton' rel='nofollow' title=" + I18n.t("fields.inventory") + "></a>",
            "<a class='fa fa-chart-line fa-lg' href='/reports' id='reportsHeaderButton' rel='nofollow' title=" + I18n.t("menu.header.reports") + "></a>",
            "<a class='fa fa-sign-out fa-lg' href='/users/sign_out' id='signoutInsideBar' data-method='delete' rel='nofollow' title=" + I18n.t("fields.sign_out") + "></a>"
        ]
    } else {
        var navbarBottomArr = [
            "<a class='fa fa-question-circle fa-lg' href='/contacts/new' id='contactsInsideBar' rel='nofollow' title=" + I18n.t("fields.contact_us") + "></a>",
            "<a class='fa fa-video fa-lg' href='/howto' id='videosInsideBar' rel='nofollow' title=" + I18n.t("menu.header.how_to_index") + "></a>"
        ];
        var iconBarTop = [
            "<a class='fa fa-sign-in fa-lg' href='/users/sign_in' id='signinIconButton' rel='nofollow' title=" + I18n.t("devise.headers.sign_in") + "></a>",
            "<a class='fa fa-user-plus fa-lg' href='/users/sign_up' id='signupIconButton rel='nofollow' title=" + I18n.t("devise.headers.sign_up") + "></a>"
        ];
        var iconBarBottom = [
            "<a class='fa fa-question-circle fa-lg' href='/contacts/new' id='contactsIconButton' rel='nofollow' title=" + I18n.t("fields.contact_us") + "></a>",
            "<a class='fa fa-sign-in fa-lg' href='/users/sign_in' id='signinInsideBar' rel='nofollow' title=" + I18n.t("devise.headers.sign_in") + "></a>"
        ]
    }

    var isWideScreen = window.matchMedia('(min-width: 768px)').matches;
    let hash = {
        wrappers: [
            "bootstrap",
            // "turbolinks",
            "angular"
        ],
        navbar: {
            title: "<img src=" + zsenie + " height='64' alt='zsenieNav' class ='zsenieNav'></img>"
        },
        keyboardNavigation: {
            enable: true,
            enhance: true
        },
        slidingSubmenus: true,
        sidebar: {
            collapsed: "(min-width: 768px)",
        },
        "extensions": [
            "pagedim-black"
        ],
        "extensions": isWideScreen ? ["pagedim-black"] : ["pagedim-black", "position-front"],
        offCanvas: {
            blockUI: true
            //moveBackground: true
        },
        "iconbar": {
            "use": true,
            "top": iconBarTop,
            "bottom": iconBarBottom
        },
        "navbars": [
            {
                "position": "top",
                "content": [
                    "prev",
                    "title"
                ]
            },
            {
                "position": "bottom",
                "content": navbarBottomArr
            }
        ]
    };

    new Mmenu("#my-menu", hash, {
            offCanvas: {
                page: {
                    selector: "#my-page"
                }
            }
        });
}

document.addEventListener(
    "turbolinks:load", () => {
        initMenu()
    }
);